export default __webpack_public_path__ + "static/media/minus.faf967b7.svg";